import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DEFAULT_AGENT_IMAGE, resolveWidgetAssetUrl } from "../config";
export function Header({ brandName, accentColor, contentColor, headerBackgroundColor, secondaryBackground, isChatting, agentImage, onBack, showBack, showInfo, onInfo, infoLabel, onClose, connectionLabel, t, }) {
    const text = contentColor || "#e2e8f0";
    const surface = headerBackgroundColor || "#e9eef5";
    const darkButton = "#1f2937";
    const avatarSource = resolveWidgetAssetUrl(agentImage) || resolveWidgetAssetUrl(DEFAULT_AGENT_IMAGE) || DEFAULT_AGENT_IMAGE;
    return (_jsxs("header", { style: {
            padding: "12px 14px",
            background: surface,
            borderBottom: "none",
            boxShadow: `0 8px 20px ${surface}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
        }, children: [_jsxs("div", { style: { display: "flex", gap: 8, alignItems: "center", minWidth: 0 }, children: [_jsxs("div", { style: { display: "flex", alignItems: "center", gap: 4, flexShrink: 0 }, children: [isChatting && showBack ? (_jsx("button", { "aria-label": t("header.back"), onClick: onBack, style: {
                                    width: 34,
                                    height: 34,
                                    border: "none",
                                    background: "transparent",
                                    color: darkButton,
                                    cursor: "pointer",
                                    fontSize: 28,
                                    lineHeight: 1,
                                    padding: 1,
                                    margin: 0,
                                }, children: "\u2039" })) : null, _jsx("div", { style: {
                                    width: 40,
                                    height: 40,
                                    borderRadius: "50%",
                                    background: "transparent",
                                    display: "grid",
                                    placeItems: "center",
                                    color: "#0b1020",
                                    fontWeight: 700,
                                    flexShrink: 0,
                                    overflow: "hidden",
                                }, children: _jsx("img", { src: avatarSource, alt: brandName, style: { width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" } }) })] }), _jsxs("div", { style: { minWidth: 0, color: text }, children: [_jsx("div", { style: { fontWeight: 700, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }, children: brandName }), connectionLabel ? (_jsx("div", { style: { fontSize: 12, color: "#64748b" }, children: connectionLabel })) : null] })] }), _jsxs("div", { style: { display: "flex", alignItems: "center", gap: 8 }, children: [showInfo && onInfo ? (_jsx("button", { "aria-label": infoLabel || t("header.flowReasoning"), onClick: onInfo, style: {
                            width: 28,
                            height: 28,
                            border: "none",
                            background: "transparent",
                            color: darkButton,
                            cursor: "pointer",
                            fontSize: 20,
                            lineHeight: 1,
                            padding: 0,
                            display: "grid",
                            placeItems: "center",
                        }, children: "\u22EF" })) : null, _jsx("button", { "aria-label": t("header.minimize"), onClick: onClose, style: {
                            width: 28,
                            height: 28,
                            border: "none",
                            background: "transparent",
                            color: darkButton,
                            cursor: "pointer",
                            display: "grid",
                            placeItems: "center",
                            padding: 0,
                        }, children: _jsx("span", { style: { display: "block", width: 14, height: 1, background: darkButton, borderRadius: 999 } }) })] })] }));
}
